import React from 'react';
export function ProductSection() {
  const handleBuyClick = () => {
    const fbq = (window as any).fbq;
    if (fbq) {
      fbq('track', 'AddToCart', {
        content_name: 'Kit Digital 33 Rituales para Soltar el Pasado',
        content_type: 'product',
        value: 16990,
        currency: 'ARS'
      });
    }
  };
  return <section className="s-mid fu" data-id="element-464">
      <div className="c relative z-10" data-id="element-465">
        <span className="slabel" data-id="element-466">El libro principal</span>
        <h2 className="stitle" data-id="element-467">
          33 Rituales para
          <br data-id="element-468" />
          <em className="text-[var(--gold-l)]" data-id="element-469">Soltar el Pasado</em>
        </h2>
        <div className="div-line" data-id="element-470"></div>

        <div className="grid grid-cols-1 md:grid-cols-[1fr_1.3fr] gap-6 md:gap-16 items-center max-w-[960px] mx-auto mt-8 md:mt-[56px] text-center" data-id="element-471">
          <div className="flex justify-center" data-id="element-472">
            <div className="relative animate-[float_7s_ease-in-out_infinite] mx-auto" data-id="element-473">
              <div className="absolute -inset-4 bg-[radial-gradient(circle,rgba(184,174,206,0.35)_0%,rgba(255,107,53,0.1)_50%,transparent_70%)] rounded-full blur-[12px]" data-id="element-474" />
              <img src="https://cdn.shopify.com/s/files/1/0752/3211/6894/files/EBOOK.png?v=1772815275" alt="33 Rituales para Soltar el Pasado" className="relative z-10 w-full max-w-[280px] md:max-w-[320px] rounded-[10px] border border-[rgba(184,174,206,0.3)] shadow-[0_20px_60px_-12px_rgba(44,37,64,0.6)] mx-auto block" data-id="element-475" />
            </div>
          </div>

          <div className="flex flex-col items-center" data-id="element-476">
            <p className="font-serif text-[clamp(1.3rem,4vw,1.6rem)] italic text-[var(--lila-pale)] leading-[1.55] md:leading-[1.6] mb-3 md:mb-4 text-center" data-id="element-477">
              "Un método simbólico para liberar emociones atrapadas, cerrar
              ciclos y recuperar tu paz interior."
            </p>
            <p className="text-[clamp(1.05rem,3vw,1.2rem)] text-[var(--text)] leading-[1.9] mb-1 text-center font-400" data-id="element-478">
              No es un libro para leer y dejar en la mesita. Es una{' '}
              <strong className="text-white font-700" data-id="element-479">
                <span className="text-[#E8C88A]" data-id="element-480">
                  experiencia práctica de liberación emocional
                </span>
              </strong>
              . Cada ritual usa el lenguaje que el inconsciente comprende: el de
              los símbolos y la acción.
            </p>

            <ul className="list-none flex flex-col gap-3 md:gap-[16px] mt-5 md:mt-7 mb-6 md:mb-9 text-center items-center max-w-[480px] mx-auto" data-id="element-481">
              <li className="flex items-start gap-2.5 text-[clamp(1.05rem,3vw,1.2rem)] text-[var(--text)] leading-[1.9] font-400 text-left w-full" data-id="element-482">
                <span className="text-[var(--gold)] text-[12px] flex-shrink-0 mt-2" data-id="element-483">
                  ✦
                </span>
                <span data-id="element-484">
                  <strong className="text-white font-700" data-id="element-485">33 rituales</strong>{' '}
                  para liberar emociones atrapadas y cerrar ciclos del pasado
                </span>
              </li>
              <li className="flex items-start gap-2.5 text-[clamp(1.05rem,3vw,1.2rem)] text-[var(--text)] leading-[1.9] font-400 text-left w-full" data-id="element-486">
                <span className="text-[var(--gold)] text-[12px] flex-shrink-0 mt-2" data-id="element-487">
                  ✦
                </span>
                <span data-id="element-488">
                  <strong className="text-white font-700" data-id="element-489">
                    Propósito emocional claro
                  </strong>{' '}
                  en cada uno — sabés exactamente para qué sirve
                </span>
              </li>
              <li className="flex items-start gap-2.5 text-[clamp(1.05rem,3vw,1.2rem)] text-[var(--text)] leading-[1.9] font-400 text-left w-full" data-id="element-490">
                <span className="text-[var(--gold)] text-[12px] flex-shrink-0 mt-2" data-id="element-491">
                  ✦
                </span>
                Elementos simples que ya tenés en casa: papel, vela, agua,
                tijeras
              </li>
              <li className="flex items-start gap-2.5 text-[clamp(1.05rem,3vw,1.2rem)] text-[var(--text)] leading-[1.9] font-400 text-left w-full" data-id="element-492">
                <span className="text-[var(--gold)] text-[12px] flex-shrink-0 mt-2" data-id="element-493">
                  ✦
                </span>
                <span data-id="element-494">
                  <strong className="text-white font-700" data-id="element-495">
                    Instrucciones paso a paso
                  </strong>{' '}
                  + reflexión final para integrar la experiencia
                </span>
              </li>
              <li className="flex items-start gap-2.5 text-[clamp(1.05rem,3vw,1.2rem)] text-[var(--text)] leading-[1.9] font-400 text-left w-full" data-id="element-496">
                <span className="text-[var(--gold)] text-[12px] flex-shrink-0 mt-2" data-id="element-497">
                  ✦
                </span>
                Sin experiencia previa ni creencias espirituales requeridas
              </li>
              <li className="flex items-start gap-2.5 text-[clamp(1.05rem,3vw,1.2rem)] text-[var(--text)] leading-[1.9] font-400 text-left w-full" data-id="element-498">
                <span className="text-[var(--gold)] text-[12px] flex-shrink-0 mt-2" data-id="element-499">
                  ✦
                </span>
                PDF descargable · Acceso inmediato y de por vida
              </li>
            </ul>

            <div className="btn-cta-wrap w-full flex justify-center" data-id="element-500">
              <a href="https://ebookpromax.com/cart/46586630013086:1" onClick={handleBuyClick} className="btn-out w-full md:w-auto" data-id="element-501">
                Ver precio y descargar
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}